<template>
<div>
	<div class="calcDescription khoranaCalculator">
        <h2>{{ title }}</h2>             
    </div>
    <div class="khoranaCalculator">
        <div id="khoranaCalculator">
            <!-- Q1 -->
            <div class="calcItem khoranaCalculator">
                <label class="d-flex align-items-center">
                    <div class="field-title">
                        {{ questions.Q1.title }}
                        <span class="required"><sup>*</sup></span>
                    </div>
                    <v-select
                        id="Q1-select"
                        v-model="form.Q1"
                        :items="questions.Q1.choices"
                        :return-object="true"
                        outlined
                        dense
                        color="secondary"
                        name="khoranaCalculator1"
                        class="khorana-select"
                    ></v-select>
                </label>
            </div>

            <!-- Q2 -->
            <div class="calcItem khoranaCalculator">
                <label>
                    <div class="field-title">
                        {{ questions.Q2.title }}
                        <span class="required"><sup>*</sup></span>
                    </div>
                    <input v-model="form.Q2" type="number" name="khoranaCalculator2"> 
                    <span style="position: absolute; right: 12px; top: 8px;">x 10<sup>9</sup>/L</span>
                </label>
            </div>

            <!-- Q3 -->
            <div class="calcItem khoranaCalculator">
                <label>
                    <div>
                        {{ questions.Q3.title }}
                        <span class="required"><sup>*</sup></span>
                    </div>
                    <v-radio-group v-model="form.Q3" class="radiogroup my-0">
                        <label v-for="(choice, index) in questions.Q3.choices">
                            <v-radio type="radio" color="secondary" :value="choice.value" name="khoranaCalculator3">
                                <template v-slot:label>
                                    <span style="color: black; margin-left: -20px;">{{ choice.text }}</span>
                                </template>
                            </v-radio>
                        </label>
                    </v-radio-group>
                </label>
            </div> 

            <!-- Q4 -->
            <div class="calcItem khoranaCalculator">
                <label>
                    <div class="field-title">
                        {{ questions.Q4.title }}
                        <span class="required"><sup>*</sup></span>
                    </div>
                    <input v-model="form.Q4" type="number" name="khoranaCalculator4">
                    <span style="position: absolute; right: 12px; top: 8px;">x 10<sup>9</sup>/L</span>
                </label>
            </div>

            <!-- Q5 -->
            <div class="calcItem khoranaCalculator">
                <label>
                    <div class="field-title">
                        {{ questions.Q5.title }}
                        <span class="required"><sup>*</sup></span>
                    </div>
                    <input v-model="form.Q5" type="number" name="khoranaCalculator5">
                    <span style="position: absolute; right: 19px; top: 8px;">kg/m<sup>2</sup></span>
                </label>
            </div>
        </div>
    </div>
</div>
</template>

<script>

export default {
    name: "khoranaCalculator",
    props: {
        language: {
            type: String,
            required: false,
            default: "en-ca"
        }
    },
    components: {

    },
    mounted() {
        this.container = document.getElementById("calcWrapper")
    },
    data() {
        return {
            form: {
                Q1: null,
                Q2: null,
                Q3: null,
                Q4: null,
                Q5: null,
            },
            title: this.getLocale({
                "en-ca": "Khorana Risk Score for VTE in Cancer Patients",
                "fr-ca": "Échelle de risque de Khorana pour la thromboembolie veineuse chez les patients atteints de cancer",
            }),
            container: null,
        }
    },
    methods: {
       getLocale(source){
            if (source){
                return source[this.language]===undefined || !source[this.language] ? source["en-ca"] : source[this.language]
            }
            return null
        },
        setScore(){
            this.container.querySelector('#calcScoreLabel').innerHTML = "Score";
            this.container.querySelector('#calcScore').innerHTML = this.score;
        },
        setScoreDescription(){
            const generalDesc = this.container.querySelector('.generalDesc')
            generalDesc.innerHTML = this.popUps[this.popUpToDisplay];
            generalDesc.style.display = 'block';
            // Fix link color
            const links = generalDesc.querySelectorAll('a');
            links.forEach(link => {
                link.style.color = '#1976d2'; // example of custom style
                link.style["font-style"] = "normal"; // example of custom style
                link.style["text-decoration"] = "underline"; // example of custom style
            });
        },
    },
    computed: {
        questions() {
            // Direct dependency on this.language to trigger recomputation
            const lang = this.language;
            return {
                Q1: {
                    title: this.getLocale({
                        "en-ca": "Site of Cancer",
                        "fr-ca": "Siège du cancer"
                    }),
                    choices: [
                        { 
                            header: this.getLocale({
                                "en-ca": "Very high risk", 
                                "fr-ca": "Risque très élevé"
                            }),
                        },
                        { 
                            text: this.getLocale({
                                "en-ca": "Brain (High Grade Glioma)", 
                                "fr-ca": "Cerveau (gliome de grade élevé)" 
                            }),
                            score: 2
                        },
                        { 
                            text: this.getLocale({
                                "en-ca": "Stomach", 
                                "fr-ca": "Estomac" 
                            }),
                            score: 2
                        },
                        { 
                            text: this.getLocale({
                                "en-ca": "Pancreas", 
                                "fr-ca": "Pancréas" 
                            }),
                            score: 2
                        },
                        { 
                            header: this.getLocale({
                                "en-ca": "High risk", 
                                "fr-ca": "Risque élevé" 
                            }),
                        },
                        { 
                            text: this.getLocale({
                                "en-ca": "Lung", 
                                "fr-ca": "Poumon" 
                            }),
                            score: 1
                        },
                        { 
                            text: this.getLocale({
                                "en-ca": "Lymphoma", 
                                "fr-ca": "Tissu lymphoïde (lymphome)" 
                            }),
                            score: 1
                        },
                        { 
                            text: this.getLocale({
                                "en-ca": "Gynecologic", 
                                "fr-ca": "Appareil reproducteur féminin" 
                            }),
                            score: 1
                        },
                        { 
                            text: this.getLocale({
                                "en-ca": "Bladder", 
                                "fr-ca": "Vessie" 
                            }),
                            score: 1
                        },
                        { 
                            text: this.getLocale({
                                "en-ca": "Testicular", 
                                "fr-ca": "Testicules" 
                            }),
                            score: 1
                        },
                        { 
                            text: this.getLocale({
                                "en-ca": "Other", 
                                "fr-ca": "Autre" 
                            }),
                            score: 0
                        },
                    ],
                },
                Q2: {
                    title: this.getLocale({
                        "en-ca": "What is the patient's platelet count?",
                        "fr-ca": "Quel est le nombre de plaquettes du patient?"
                    })
                },
                Q3: {
                    title: this.getLocale({
                        "en-ca": "Is the patient’s hemoglobin level less than 100 g/L or are they on red cell growth factors?",
                        "fr-ca": "Le taux d’hémoglobine du patient est-il inférieur à 100 g/L ou le patient prend-il des facteurs de croissance érythrocytaires?"
                    }),
                    choices: [
                        { 
                            text: this.getLocale({
                                "en-ca": "Yes", 
                                "fr-ca": "Oui" 
                            }),
                            value: {
                                score: 1
                            }
                        },                        { 
                            text: this.getLocale({
                                "en-ca": "No", 
                                "fr-ca": "Non" 
                            }),
                            value: {
                                score: 0
                            }

                        },
                    ]
                },
                Q4: {
                    title: this.getLocale({
                        "en-ca": "What is the patient’s leukocyte count?",
                        "fr-ca": "Quel est le nombre de leucocytes du patient?"
                    }), 
                },
                Q5: {
                    title: this.getLocale({
                        "en-ca": "What is the patient's BMI?",
                        "fr-ca": "Quel est l’IMC du patient?"
                    }), 
                }
            };
        },
        score() {
            let score = 0 
            // Q1
            const Q1Input = this.form.Q1
            if (Q1Input && Q1Input.score) {
                score += Q1Input.score 
            }

            // Q2
            const Q2Input = Number(this.form.Q2)
            if (Q2Input && Number.isInteger(Q2Input)) {
                if (Q2Input >= 350) {
                    score += 1
                }
            }
            
            // Q3
            const Q3Input = this.form.Q3
            if (Q3Input && Q3Input.score) {
                score += Q3Input.score 
            }

            // Q4
            const Q4Input = Number(this.form.Q4)
            if (Q4Input && Number.isInteger(Q4Input)) {
                if (Q4Input > 11) {
                    score += 1
                }
            }

            // Q5
            const Q5Input = Number(this.form.Q5)
            if (Q5Input && Number.isInteger(Q5Input)) {
                if (Q5Input >= 35) {
                    score += 1
                }
            }

            return score
        },
        popUps() {
            // Direct dependency on this.language to trigger recomputation
            const lang = this.language;
            return {
                P1: this.getLocale({
                    "en-ca": `
                        <b>Low risk</b>: Monitor Patient,
                        <br>
                        Low-risk outpatients with solid cancers or lymphomas (Khorana score of 1 or lower prior to starting a new systemic chemotherapy regimen) should be offered education on the signs and symptoms of deep vein thrombosis and pulmonary embolism. Please consider sharing 1 or more of the following resources:
                        <br>
                        <a href="/hcp/practice/patient_support/cancer_associated_thrombosis_patient_resource_library">
                            Cancer-associated Thrombosis Patient Resource Library
                        </a>
                        <br>
                        <a href="/patients_and_caregivers/about_thrombosis/ssrf/clots">
                            CLOTS Brochure
                        </a>
                        <br>
                        <a href="/resource/119/en-ca">
                            Cancer-associated Thrombosis: Know the Risks Brochure 
                        </a>
                        <br>
                        Video:
                        <a href="https://www.youtube.com/watch?v=W12rn4IbLMA" target="_blank">
                            Illustrated Video
                        </a>
                    `,
                    "fr-ca": `
                        <b>Faible risque</b>: suivre le patient.
                        <br>
                        Les patients en soins ambulatoires atteints d’un cancer d’un organe solide ou d’un lymphome à faible risque (score de Khorana ≤ 1 avant le début d’une nouvelle chimiothérapie) devraient recevoir de l’information sur les signes et symptômes de la thrombose veineuse profonde et de l’embolie pulmonaire.
                        <br>
                        Pensez à leur faire part de l’une des ressources suivantes ou plus :
                        <br>
                        <a href="/hcp/practice/patient_support/cancer_associated_thrombosis_patient_resource_library">
                            Thrombose associée au cancer – Bibliothèque de ressources pour les patients
                        </a>
                        (en cliquant sur FR pour accéder à la version française)
                        <br>
                        ${this.isProductionEnv ? 
                            `<a href="/resource/171/fr-ca">
                                Brochure « VESSO » 
                            </a>` :
                            `<a href="https://thrombosiscanada.ca/resource/171/fr-ca">
                                Brochure « VESSO » 
                            </a>`
                        }
                        <br>
                        ${this.isProductionEnv ? 
                            `<a href="/resource/119/fr-ca">
                                Brochure « Thrombose associée au cancer : connaître les risques »
                            </a>` :
                            `<a href="https://thrombosiscanada.ca/resource/119/fr-ca">
                                Brochure « Thrombose associée au cancer : connaître les risques »
                            </a>`
                        }
                        <br>
                        Vidéo (en anglais):
                        <a href="https://www.youtube.com/watch?v=W12rn4IbLMA" target="_blank">
                            vidéo illustrative
                        </a>
                    `
                }), 
                P2: this.getLocale({
                    "en-ca": `
                        <b>Moderate - High risk</b>: Consider thromboprophylaxis as follows
                        <br>
                        High-risk outpatients with solid cancers or lymphomas (Khorana score of 2 or higher prior to starting a new systemic chemotherapy regimen) may be offered thromboprophylaxis with apixaban, rivaroxaban, or low molecular-weight heparin (LMWH) provided there are no significant risk factors for bleeding, no significant thrombocytopenia, creatinine clearance > 30 cc/min and no drug interactions. Consideration of such therapy should be accompanied by a discussion with the patient about the relative benefits and harms, drug cost, and duration of prophylaxis in this setting.
                        <br>
                        For more information on thromboprophylaxis recommendations, see the following Thrombosis Canada Clinical Guides:  
                        <br>
                        <a href="/hcp/practice/clinical_guides?language=en-ca&guideID=CANCERANDTHROMBOSIS">
                            Cancer and Thrombosis 
                        </a>
                        <br>
                        <a href="/hcp/practice/clinical_guides?language=en-ca&guideID=APIXABAN">
                            Apixaban
                        </a>
                        <br>
                        <a href="/hcp/practice/clinical_guides?language=en-ca&guideID=RIVAROXABAN">
                            Rivaroxaban 
                        </a>
                        <br>
                        <a href="/hcp/practice/clinical_guides?language=en-ca&guideID=UNFRACTIONATEDHEPARINANDLOWMOL">
                            Unfractionated Heparin, Low Molecular Weight Heparin and Fondaparinux 
                        </a>
                        <br>
                        <br>
                        Share these resources with your patients:
                        <br>
                        <a href="/hcp/practice/patient_support/cancer_associated_thrombosis_patient_resource_library">
                            Cancer-associated Thrombosis Patient Resource Library
                        </a>
                        <br>
                        <a href="/resource/119/en-ca">
                            Cancer-associated Thrombosis: Know the Risks Brochure
                        </a>
                        <br>
                        Video:
                        <a href="https://www.youtube.com/watch?v=W12rn4IbLMA" target="_blank">
                            Illustrated Video
                        </a>
                    `,
                    "fr-ca": `
                        <b>Risque modéré à élevé</b>: envisager une thromboprophylaxie de la façon décrite ci-dessous.
                        <br>
                        Les patients en soins ambulatoires atteints d’un cancer d’un organe solide ou d’un lymphome à risque élevé (score de Khorana de 2 ou plus avant le début d’une nouvelle chimiothérapie) peuvent se voir proposer une thromboprophylaxie par l’apixaban, le rivaroxaban ou une héparine de bas poids moléculaire (HBPM) à condition qu’ils ne présentent pas de facteur de risque hémorragique important, qu’ils ne présentent pas de thrombocytopénie significative, qu’ils présentent une clairance de la créatinine > 30 mL/min et en l’absence d’interactions médicamenteuses. La décision de prescrire une thromboprophylaxie doit s’accompagner d’une discussion avec le patient sur les bénéfices et les risques relatifs, le coût du médicament et la durée de la prophylaxie dans ce contexte.
                        <br>
                        Pour de plus amples renseignements sur les recommandations en matière de thromboprophylaxie, consulter les guides cliniques suivants de Thrombose Canada: 
                        <br>
                        <a href="/hcp/practice/clinical_guides?language=fr-ca&guideID=FR_CANCERETTHROMBOSE">
                            Cancer et thrombose 
                        </a>
                        <br>
                        <a href="/hcp/practice/clinical_guides?language=fr-ca&guideID=FR_APIXABAN">
                            Apixaban
                        </a>
                        <br>
                        <a href="/hcp/practice/clinical_guides?language=fr-ca&guideID=FR_RIVAROXABAN">
                            Rivaroxaban 
                        </a>
                        <br>
                        <a href="/hcp/practice/clinical_guides?language=fr-ca&guideID=FR_HPARINENONFRACTIONNEETHPARINED">
                            Héparine non fractionnée, héparine de bas poids moléculaire et fondaparinux 
                        </a>
                        <br>
                        <br>
                        Partagez ces ressources avec vos patients:
                        <br>
                        <a href="/hcp/practice/patient_support/cancer_associated_thrombosis_patient_resource_library">
                            Thrombose associée au cancer – Bibliothèque de ressources pour les patients
                        </a>
                        <br>

                        ${this.isProductionEnv ? 
                            `<a href="/resource/119/fr-ca">Brochure « Thrombose associée au cancer : connaître les risques »</a>` :
                            `<a href="https://thrombosiscanada.ca/resource/119/fr-ca">Brochure « Thrombose associée au cancer : connaître les risques »</a>`
                        }
                        <br>
                        Vidéo (en anglais):
                        <a href="https://www.youtube.com/watch?v=W12rn4IbLMA" target="_blank">
                            vidéo illustrative
                        </a>
                    `,
                })
            }
        },
        popUpToDisplay() {
            if (this.score < 2) {
                return "P1"
            }
            return "P2"
        },
        validForm() {
            const form = this.form
            for (let key in form) {
                if (form[key] === null) {
                    return false;
                }
            }
            return true;
        },
        isProductionEnv() {
            return process.env.VUE_APP_ENV === 'production'
        }
    },
    watch: {
        form: {
            handler() {
                if (this.validForm) {
                    this.setScore()
                    this.setScoreDescription()
                }
            },
            deep: true
        }
    }
}

</script>

<style lang="scss" scoped>
:deep(input#Q1-select) {
    visibility: hidden;
}

.required {
    color: red;
    font-size: 1.2em;
}


:deep(.v-messages) {
    display: none;
}

.calcItem input[type="text"], .calcItem input[type="number"] {
    right: 70px;
}

.calcItem label {
    padding-left: 0px;
}

.khorana-select {
    max-width: 300px;
    margin-left: auto !important;
    margin-top: 5px !important;
    font-size: 16px;
}

@media (max-width: 650px) {
    .field-title {
        width: 50%;
    }

    .khorana-select {
        font-size: 14px;
    }
}

</style>